import PageHero from "../components/PageHero";
import SmartLink from "../components/SmartLink";
import { ArrowRightIcon } from "../components/Icons";

/**
 * Several footer links (Changelog, Integrations, Careers, Community) point at
 * routes that also 404 on the current live site - they are advertised but were
 * never built. Rather than reproduce the 404, they land here with an honest
 * message. Replace these routes with real pages, or drop the links, when you
 * have the content.
 */
export default function ComingSoonPage({ title }: { title: string }) {
  return (
    <>
      <PageHero
        eyebrow="Coming soon"
        title={title}
        intro={`The ${title.toLowerCase()} page hasn't been published yet.`}
      />

      <section className="section-pad bg-white">
        <div className="container-page">
          <div className="card mx-auto max-w-2xl p-8 text-center shadow-card sm:p-12">
            <p className="text-sm leading-relaxed text-ink-muted">
              This section is planned but not written yet. In the meantime our team is
              happy to answer anything directly.
            </p>
            <div className="mt-8 flex flex-col items-center justify-center gap-3 sm:flex-row">
              <SmartLink href="/contact" className="btn-primary w-full sm:w-auto">
                Talk to us
                <ArrowRightIcon />
              </SmartLink>
              <SmartLink href="/" className="btn-ghost w-full sm:w-auto">
                Back to home
              </SmartLink>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
